// Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
// See LICENSE in the project root for license information.

export class Debug {
  // To debug the plugin, temporarily uncomment the body of this function
  public static log(message: string): void {
    // message = require("process").pid + ": " + message;
    // console.log(message);
    // require('fs').writeFileSync('C:\\Git\\log.txt', message + '\r\n', { flag: 'as' });
  }
}
